import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import StepOne from './components/StepOne';
import StepTwo from './components/StepTwo';
import StepThree from './components/StepThree';
import StepFour from './components/StepFour';
import Header from './components/Header';
import StepProgressIndicator from './components/StepCircle';

const RequestPage = () => {
  const { control, formState: { errors }, setValue } = useForm();
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    marka: '',
    model: '',
    godina: '',
    motor: '',
    brojSasije: '',
    opis: '',
    email: '',
    number: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    setValue(name, value);
  };

  const handleNext = () => {
    setStep(prev => prev + 1);
  };

  const handleFinish = () => {
    const { number, ...dataWithoutPhone } = formData;
    localStorage.setItem('formData', JSON.stringify(dataWithoutPhone));
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerWrapper}>
        <Header step={step} />
      </div>
      <div style={styles.progressWrapper}>
        <StepProgressIndicator step={step} />
      </div>
      {step === 1 && <StepOne data={formData} onChange={handleChange} onNext={handleNext} />}
      {step === 2 && <StepTwo data={formData} onChange={handleChange} onNext={handleNext} />}
      {step === 3 && 
        <StepThree 
          data={formData} 
          onChange={handleChange} 
          control={control} 
          setValue={setValue} 
          errors={errors} 
          onNext={handleNext}  
        />
      }
      {step === 4 && <StepFour data={formData} control={control} onNext={handleFinish} />}
      <footer style={styles.footer}>
        Copyright © 2025. SmartPart d.o.o. • Sva prava zadržana
      </footer>
    </div>
  );
};

export default RequestPage;

const styles = {
  container: {
    backgroundColor: '#171718',
    color: '#fff',
    minHeight: '100vh',
    padding: '40px',
    fontFamily: 'sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerWrapper: {
    width: '100%',
    marginBottom: 40,
  },
  progressWrapper: {
    marginBottom: 40,
  },  
  footer: {
    textAlign: 'center',
    marginTop: 'auto',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal', 
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },
};
